import { useMutation, useQueryClient } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';
import { API_URL } from '@/config';

export interface AddWorkflowCheckpointPayload {
  version: number;
  commit_message: string;
  api_workflow_file_id: string;
  normal_workflow_file_id: string;
  workflow_id: string;
  workflow_name: string;
  created_at: string; // ISO
  commit_author: string;
  api_config: {
    inputs: Record<string, any>[];
    outputs: Record<string, any>[];
    is_manual: boolean;
  };
}

export const addWorkflowCheckpoint = async ({
  project_id,
  payload,
}: {
  project_id: string;
  payload: AddWorkflowCheckpointPayload;
}): Promise<any> => {
  const access_token = storage.getToken();

  if (!access_token || !project_id) {
    return;
  }

  try {
    const response = await axios.post(`${API_URL}/v2/project/${project_id}/checkpoint`, payload);
    return response;
  } catch (error) {
    // throw error;
  }
};

export const useAddWorkflowCheckpoint = (config = {}) => {
  const { addNotification } = useNotificationStore();
  const queryClient = useQueryClient();

  return useMutation<any, Error, { project_id: string; payload: AddWorkflowCheckpointPayload }>({
    mutationFn: addWorkflowCheckpoint,
    onError: (error: any) => {
      addNotification({
        type: 'error',
        title: 'Failed to add checkpoint',
        message: error?.response?.data?.data,
        delay: 6000,
      });
    },
    onSuccess: (data, variables) => {
      if (data) {
        addNotification({
          type: 'success',
          title: 'Version Added',
        });
        queryClient.invalidateQueries(['workflowCheckpoints', variables.project_id]);
      }
    },
    ...config,
  });
};
